import {
  Flex,
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Icon,
  Divider,
  VStack,
  InputRightElement,
  IconButton,
  InputGroup,
  Image,
  HStack,
  Avatar,
  chakra,
  useBreakpointValue,
  Tag,
  Spinner,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { FcGoogle } from 'react-icons/fc'
import { useForm } from 'react-hook-form'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { userState } from '../../recoil/atoms/auth'
import { auth, db } from '../../firebase/config'
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  sendSignInLinkToEmail,
} from 'firebase/auth'
import { collection, doc, getDoc, getDocs, limit, orderBy, query, setDoc, where } from 'firebase/firestore'
import { FaFacebook, FaLock, FaLockOpen } from 'react-icons/fa'
import { useCustomToast } from '../../hooks/customToast'
import { format } from 'date-fns'
import { errorToast, } from '../../utils'
// import { getPlans, } from '../../firebase/stripeConfig';
import shortLogo from '../../assets/images/android-chrome-192x192.png'
import { saveLoginLogs } from './utils'
import { LinkIcon } from '@chakra-ui/icons'

const provider = new GoogleAuthProvider()
const providerFacebook = new FacebookAuthProvider()

export default function SimpleCard() {
  const { addToast } = useCustomToast()
  const { pathname } = useLocation();
  const user = useRecoilValue(userState)
  const [maginLinkLoader, setMaginLinkLoader] = useState(false)
  const [googleLoader, setGoogleLoader] = useState(false)
  const [facebookLoader, setFacebookLoader] = useState(false)
  const [blogLoading, setBlogLoading] = useState(false)
  const [latestBlog, setLatestBlog] = useState(null)

  const [showPass, setShowPass] = useState({
    password: false,
    confirmPassword: false,
  })

  const handleShowPass = (name) => {
    return setShowPass((prev) => ({ ...prev, [name]: !prev[name] }))
  }

  const isMobile = useBreakpointValue({
    base: true,
    sm: true,
    md: false,
  })

  // const navigate = useNavigate()
  // const [plans, setPlans] = useState(null)

  // useEffect(() => {
  //   (async () => {
  //     const plans = await getPlans()
  //     setPlans(plans)
  //   })()
  // }, [])

  const {
    handleSubmit,
    register,
    watch,
    setError,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const setUser = useSetRecoilState(userState)

  const actionCodeSettings = {
    url: window.location.href,
    handleCodeInApp: true,
  };

  const trySignIn = async () => {
    setMaginLinkLoader(true)
    sendSignInLinkToEmail(auth, watch('email'), actionCodeSettings)
      .then(() => {
        // Save the users email to verify it after they access their email
        window.localStorage.setItem("emailForSignIn", watch('email'));
        addToast({
          title: 'Check your email!',
          description: 'Signin Link sent Successfully',
          status: 'success',
          variant: 'left-accent',
        })
        reset()
        setMaginLinkLoader(false)
      })
      .catch((err) => {
        setMaginLinkLoader(false)
        switch (err.code) {
          default:
            console.log({ err })
            setError('email', {
              type: 'custom',
              message: err.message
            })
        }
      });
  };

  const login = async (values) => {
    try {
      const res = await signInWithEmailAndPassword(auth, values.email, values.password)

      const docRef = doc(db, 'users', res.user.uid)
      const userSnap = await getDoc(docRef)
      // console.log(res)

      const docId = await saveLoginLogs({
        userEmail: values?.email || '',
        userId: res.user.uid
      })
      // console.log({ docId })
      setUser({ ...userSnap.data(), loginId: docId })
      addToast({
        title: 'Welcome Back!',
        description: 'Login Successfully',
        status: 'success',
        variant: 'left-accent',
      })

    } catch ({ message }) {
      addToast({ title: 'Error', description: message, status: 'error', variant: 'left-accent' })
    }
  }

  const handleGoogleSignIn = async () => {
    try {
      setGoogleLoader(true)
      const { user } = await signInWithPopup(auth, provider)
      const data = {
        firstName: user.displayName.split(' ')[0] || '',
        lastName: user.displayName.split(' ')[1] || '',
        phoneNumber: user.phoneNumber,
        email: user.email,
        uid: user.uid,
        photoURL: '',
      }

      const docRef = doc(db, 'users', user.uid)
      const userSnap = await getDoc(docRef)
      !userSnap.exists() && (await setDoc(docRef, data))

      const docId = await saveLoginLogs({
        userEmail: user?.email || '',
        userId: user.uid,
        ...(!userSnap.exists() && ({
          firstLogin: true,
        }))
      })
      // console.log({ docId })

      !userSnap.exists() && setUser({ ...data, loginId: docId })
      userSnap.exists() && setUser(userSnap.data())

      addToast({
        title: 'Welcome Back!',
        description: 'Login Successfully',
        status: 'success',
        variant: 'left-accent',
      })
      setGoogleLoader(false)
      // navigate('/dashboard', { replace: true })
    } catch ({ message }) {
      setGoogleLoader(false)
      addToast({ title: 'Error', description: message, status: 'error', variant: 'left-accent' })
    }
  }

  const handleFacebookSignIn = async () => {
    try {
      setFacebookLoader(true)
      const { user } = await signInWithPopup(auth, providerFacebook)
      const data = {
        firstName: user.displayName.split(' ')[0] || '',
        lastName: user.displayName.split(' ')[1] || '',
        phoneNumber: user.phoneNumber,
        email: user.email,
        uid: user.uid,
        photoURL: user.photoURL || '',
      }

      const docRef = doc(db, 'users', user.uid)

      const userSnap = await getDoc(docRef)

      !userSnap.exists() && (await setDoc(docRef, data))

      const docId = await saveLoginLogs({
        userEmail: user?.email || '',
        userId: user.uid,
        ...(!userSnap.exists() && ({
          firstLogin: true,
        }))
      })
      // console.log({ docId })

      !userSnap.exists() && setUser({ ...data, loginId: docId })
      userSnap.exists() && setUser(...data, ...userSnap.data())

      addToast({
        title: 'Welcome Back!',
        description: 'Login Successfully',
        status: 'success',
        variant: 'left-accent',
      })

      setFacebookLoader(false)
    } catch ({ message }) {
      setFacebookLoader(false)
      addToast({ title: 'Error', description: message, status: 'error', variant: 'left-accent' })
    }
  }

  const blogDoc = {
    "blogDesc": "Boost your brand with social proof. Learn six compelling reasons why video reviews can increase sales and credibility.",
    "id": "pIkrmLPJXPYQorcNUSfL",
    "blogs": [
      {
        "value": "36VyEa5t30cKPjcOiXhw",
        "label": "The Ultimate Secret to Boosting Sales: 5 Proven Strategies to Leverage Video Reviews"
      },
      {
        "value": "yOBsa4nfSVXrLcn28AHK",
        "label": "Why does social proof matter to small businesses? "
      },
      {
        "value": "m8BAAeRsCn8MuyCfE5OC",
        "label": "5 Steps to Improving Your SEO with Video Reviews"
      }
    ],
    "userId": "TARmgF2iocYjKHEpFi77hJVD7JL2",
    "category": "news",
    "blogContent": "## I. Introduction\n\nBuilding a solid brand reputation is essential for success in today's competitive business landscape. Social proof, the concept that people are more likely to trust and follow the actions of others, is a powerful tool that can help businesses establish credibility and trust with their target audience.\n\nAt its core, social proof relies on the idea that people want to know they are making the right choice. They want to see evidence that others have made the same decision and have had a positive outcome. Social proof comes in many forms, from customer reviews and testimonials to influencer endorsements and social media engagement.\n\nIn this article, we will explore six compelling reasons why social proof should be a crucial part of your marketing strategy and the different types of social proof that businesses can leverage to increase brand credibility and drive sales. We will also discuss best practices for incorporating social proof into your marketing materials and managing your online reputation.\n\nLet's dive in!\n## II. 6 Reasons to Use Social Proof for Business Success\n\n1. Increased sales and conversions: Social proof can be a powerful motivator for customers to purchase. When they see that others have had a positive experience with your product or service, they are more likely to buy.\n2. Enhanced brand credibility and reputation: By showcasing positive reviews and testimonials, businesses can establish themselves as trusted and reputable brand. This can lead to greater customer loyalty and repeat business.\n3. Greater customer engagement and loyalty: Social proof can encourage customers to engage with your brand and become advocates. Sharing their positive experiences with others can lead to a snowball effect of positive word-of-mouth marketing.\n4. Cost-effective marketing strategy: Social proof is a relatively low-cost marketing tactic that can deliver significant results. Businesses can build credibility and trust by leveraging customer reviews and testimonials without breaking the bank.\n5. Competitive advantage: In today's crowded marketplace, businesses must find ways to stand out. By incorporating social proof into their marketing strategy, they can differentiate themselves from competitors and attract more customers.\n6. Improved customer experience: Businesses can gain valuable insights into what their customers want and need by leveraging social proof. This can help them improve their products and services and deliver a better customer experience.\n\nBy utilizing social proof in these ways, businesses can establish a strong brand reputation and drive sales and revenue. In the next section, we will explore the different types of social proof and how to leverage them for maximum impact.\n## III. Types of Social Proof\n\nSocial proof can come in many forms, each with unique benefits and advantages. Here are some of the most common types of social proof that businesses can leverage to increase brand credibility and drive sales:\n\n1. Customer testimonials: Written or spoken endorsements from satisfied customers can be a powerful form of social proof. By sharing their positive experiences with others, customers can help build trust and credibility for your brand.\n2. Video reviews: Video testimonials or reviews can be an even more powerful form of social proof. They provide a more personal and authentic glimpse into the customer experience and can be highly engaging for potential customers.\n3. Influencer marketing: Partnering with influencers in your industry or niche can be a highly effective way to build social proof. Influencers' endorsement of your product or service can increase credibility and trust with their followers.\n4. Social media engagement: Likes, comments, and shares on social media can also be a form of social proof. When potential customers see that others are engaging with your brand on social media, it can build credibility and increase the chances of a sale.\n5. Word-of-mouth marketing: Personal recommendations from friends and family can be some of the most potent forms of social proof. By encouraging satisfied customers to share their positive experiences with others, businesses can tap into the power of word-of-mouth marketing.\n\nBusinesses can develop a powerful marketing strategy that resonates with their target audience by understanding the different types of social proof and how they can be leveraged. The following section will explore the science behind social proof and why it is so effective.\n## IV. The Science of Social Proof\n\nThe power of social proof is rooted in the psychology of human behavior. People are social creatures who are naturally inclined to follow the actions of others. They are more likely to follow suit when they see evidence that others have made a particular choice or decision.\n\nOne of the main reasons why social proof is so compelling is that it reduces the perceived risk of making a purchase or decision. When people see that others have had a positive experience with a product or service, they feel more confident buying.\n\nAnother reason why social proof is compelling is that it provides a shortcut for decision-making. In a world with countless options and choices, people are often overwhelmed and need guidance on what to choose. Social proof can help simplify decision-making by clearly indicating what others have chosen and why.\n\nFinally, social proof is compelling because it fits our desire for social validation. People want to feel that they are part of a community and that others validate their choices. Seeing that others have made the same choice can provide a sense of validation and affirmation.\n\nBy understanding the science behind social proof and why it is so effective, businesses can develop more effective marketing strategies and tap into the power of social influence. The following section will explore using social proof to increase sales and drive business success.\n\n## V. Using Social Proof to Boost Your Brand\n\nNow we understand the different types of social proof and the science behind its effectiveness. Let's explore how to incorporate social proof into your marketing strategy to increase sales and drive business success.\n\n1. Incorporate social proof into your website and marketing materials: One of the most effective ways to leverage social proof is by incorporating customer reviews, testimonials, and endorsements into your website and marketing materials. This can help build trust and credibility with potential customers and increase the chances of a sale.\n2. Leverage video reviews: As mentioned earlier, video reviews can be a potent form of social proof. Businesses can provide a more personal and engaging look into the customer experience by encouraging satisfied customers to record a video testimonial.\n3. Use social proof in advertising: Social proof can also be effective in advertising campaigns. Incorporating customer reviews and endorsements into your ads can increase the likelihood of a click and conversion.\n4. Monitor and respond to customer feedback: Social proof is only practical if genuine and authentic. That's why monitoring customer feedback and responding to negative comments or reviews is essential. You can build even more trust and credibility by showing that you care about your customers and are committed to providing a great experience.\n5. Utilize social media: Social media is an excellent platform for building social proof. You can increase brand awareness and credibility by encouraging customers to share their experiences and engage with your brand on social media.\n6. Showcase your expertise: Another form of social proof is demonstrating your expertise in your industry or niche. You can establish yourself as a trusted authority by publishing thought leadership content and speaking at industry events.\n\nBy leveraging social proof in these ways, businesses can establish a strong brand reputation and drive sales and revenue. The following section will explore how to manage your online reputation to ensure your social proof remains positive and effective.\n\n## VI. Managing Your Online Reputation\n\nWhen it comes to social proof, reputation is everything. That's why it's essential to actively manage your online reputation to ensure your social evidence remains positive and effective.\n\nHere are some tips for managing your online reputation:\n\n1. Monitor customer feedback: Regularly monitor customer feedback on review sites and social media platforms. This will help you identify and address potential issues early before they become more significant problems.\n2. Respond to negative feedback: When you receive negative feedback, responding promptly and professionally is essential. Could you acknowledge the customer's concerns and work to resolve the issue to their satisfaction?\n3. Encourage positive feedback: Encourage satisfied customers to leave positive reviews and share their experiences on social media. This can help offset negative feedback and build a strong base of social proof.\n4. Be proactive: Take action before negative feedback comes in. I'd like you to proactively seek out feedback from customers and work to address any issues before they become more significant problems.\n5. Build a strong brand identity: By building a solid brand identity, businesses can establish themselves as a trusted and reputable brand. This can help mitigate potential negative feedback and build a strong base of social proof.\n6. Work with a reputation management service: If managing your online reputation feels overwhelming, consider working with a reputation management service. These services can help monitor your online presence, respond to feedback, and build a strong base of social proof.\n\nBy actively managing their online reputation, businesses can ensure that their social proof remains positive and effective. This can help build trust and credibility with potential customers and drive business success. In the final section, we will sumarize the importance of social proof and provide some final thoughts and actionable tips.\n\n## VII. Conclusion\n\nSocial proof is a powerful tool that can help businesses establish credibility and trust with their target audience. By leveraging customer reviews, testimonials, and endorsements, businesses can build a strong base of social proof that can increase sales and drive business success.\n\nIn this article, we've explored six compelling reasons why social proof should be a key part of your marketing strategy, as well as the different types of social proof that businesses can leverage to increase brand credibility and drive sales. We've also discussed best practices for incorporating social proof into your marketing materials and managing your online reputation.\n\nTo recap, here are some key takeaways:\n\n- Social proof reduces the perceived risk of making a purchase or decision.\n- Social proof provides a shortcut for decision-making in a world with countless options and choices.\n- Social proof taps into our desire for social validation.\n- Social proof can be incorporated into your website, marketing materials, and advertising campaigns.\n- Social proof is most effective when it is genuine and authentic.\n- Reputation management is essential for maintaining positive social proof.\n\nBy following these best practices and incorporating social proof into your marketing strategy, businesses can establish a strong brand reputation and drive sales and revenue. Remember, social proof is not a one-time fix but an ongoing process that requires active management and cultivation.\n\nThank you for reading, and we hope you found this article helpful!",
    "wordsUrl": "compelling-reasons-to-use-social-proof-for-business-success",
    "blogTitle": "6 Compelling Reasons to Use Social Proof for Business Success: How Video ReviewsCan Boost Your Brand",
    "publishedDate": {
      "seconds": 1683394961,
      "nanoseconds": 914000000
    },
    "headerImg": "https://res.cloudinary.com/codeshock/image/upload/v1680904275/sendmea/imgs/pIkrmLPJXPYQorcNUSfL.jpg",
    "publishedAt": {
      "seconds": 1680904278,
      "nanoseconds": 527000000
    },
    "publish": true
  }

  // let unsubscribe;

  useEffect(() => {
    if (db && !user) {
      (async () => {
        try {
          setBlogLoading(true)
          const blogsRef = collection(db, 'blogs')
          const blogsRefQuery = query(
            blogsRef,
            where('publish', '==', true),
            orderBy('publishedDate', 'desc'), limit(1)
          )

          // eslint-disable-next-line react-hooks/exhaustive-deps
          // const unsubscribe = onSnapshot(blogsRefQuery, (blogsSnap) => {
          const blogsSnap = await getDocs(blogsRefQuery)
          let results = []
          blogsSnap.docs.forEach((doc) => {
            results.push({ ...doc.data(), id: doc.id })
          })
          // console.log(results)
          setLatestBlog(results[0])
          setBlogLoading(false)

        } catch (error) {
          console.log(error)
          errorToast(error, addToast)
          setBlogLoading(false)
        }
      })()
    }

  }, [])

  return (
    <Flex
      minH={'calc(100vh - 70px)'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('white', 'gray.800')}
      width={['full']}
      mb={10}
      py={[12, 8, 6]}
    >
      <Stack
        maxW={isMobile ? '550px' : '1050px'}
        direction={isMobile ? 'column' : 'row'}
        alignItems='stretch'
        w={'full'}
        spacing={0} margin='auto'
        // px={[2, 6]}
        // p={[4, 8]}
        rounded={'lg'}
        bg={useColorModeValue('white', 'gray.700')}
        boxShadow={'0 2px 25px 0 rgba(48,58,156,.15)'}
        mx={[4, 6, 8]}

      >
        {/* <Stack align={'center'}>
          <Heading fontSize={['2xl', '4xl', '5xl']}>Sign in to your account</Heading>
          <Text fontSize={['md', 'lg']} color={'gray.600'}>
            to enjoy all of our cool features ✌️
          </Text>
        </Stack> */}
        <Box
          // p={['30px', '40px', '50px']}
          px={['25px', '35px', '45px']}
          py={['20px', '25px']}
          width='full' height='100%'
          flex={1}
          borderRight={'1px solid'}
          borderColor='gray.100'
          margin={'auto'}
        >
          <Stack spacing={6} w='full' justifyContent='center'>
            <Stack align={'center'}>
              <Heading fontSize={['2xl', '4xl', '5xl']}>Sign in to your account</Heading>
              <Text fontSize={['md', 'lg']} color={'gray.600'}>
                To enjoy all of our cool features ✌️
              </Text>
            </Stack>
            <form onSubmit={handleSubmit(login)}>

              <FormControl isInvalid={!!errors?.email}>
                <FormLabel display={'flex'} justifyContent={'space-between'}>Email address
                  <Button variant={'ghost'} onClick={trySignIn} isLoading={maginLinkLoader}>
                    <LinkIcon color={'brand.1'} />
                  </Button></FormLabel>
                <Input
                  placeholder='Email'
                  type='email'
                  {...register('email', {
                    required: 'This is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address',
                    },
                  })}
                  size={['sm', 'md']}
                />
                {errors.email && <FormErrorMessage>{errors.email.message}</FormErrorMessage>}
              </FormControl>
              <FormControl isInvalid={!!errors?.password}>
                <FormLabel mt={4}>Password</FormLabel>
                <InputGroup>
                  <Input
                    placeholder='Password'
                    type={showPass.password ? 'text' : 'password'}
                    {...register('password', {
                      required: 'This is required',
                      minLength: {
                        value: 6,
                        message: 'Minimum length should be 6',
                      },
                    })}
                    size={['sm', 'md']}
                  />
                  <InputRightElement>
                    <IconButton
                      variant='ghost'
                      color='brand.1'
                      size='sm'
                      onClick={() => handleShowPass('password')}
                    >
                      {showPass.password ? <FaLockOpen /> : <FaLock />}
                    </IconButton>
                  </InputRightElement>
                </InputGroup>
                {errors.password && <FormErrorMessage>{errors.password.message}</FormErrorMessage>}
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}
                  mt={4}
                >
                  <Checkbox colorScheme={'teal'}>Remember me</Checkbox>
                  <Link
                    as={RouterLink}
                    to={'/password-reset'}
                    color={'teal.400'}
                    _hover={{ textDecoration: 'none', color: 'teal.500' }}
                  >
                    Forgot password?
                  </Link>
                </Stack>
                {pathname !== "/login" && <Text color={'red.500'} fontSize={'md'} textAlign={'center'}>Please sign in first!</Text>}
                <VStack spacing={[2.5]} alignItems='stretch'>
                  <Button type='submit' isLoading={isSubmitting} variant='solid'>
                    Sign in
                  </Button>
                  <Divider sx={{ marginTop: ['0.8rem !important', '1rem !important'] }} />
                  <Button
                    onClick={handleGoogleSignIn}
                    isLoading={googleLoader}
                    variant={'solid'}
                    bg={'white'}
                    border={'1px solid gray'}
                    borderColor={'gray.300'}
                    color={'black'}
                    _hover={{
                      bg: 'rgba(0,0,0,0.05)',
                      borderColor: 'gray.300',
                    }}
                    sx={{ marginTop: ['0.8rem !important', '1rem !important'] }}
                    leftIcon={<Icon as={FcGoogle} />}
                  >
                    Google
                  </Button>
                  <Divider sx={{ marginTop: ['0.8rem !important', '1rem !important'] }} />
                  <Button
                    colorScheme='facebook'
                    leftIcon={<FaFacebook />}
                    variant={'solid'}
                    bg={'facebook.400'}
                    border={'1px solid'}
                    _hover={{
                      bg: 'facebook.300',
                      borderColor: 'facebook.300',
                    }}
                    onClick={handleFacebookSignIn}
                    isLoading={facebookLoader}
                  >
                    Facebook
                  </Button>
                </VStack>
              </Stack>
            </form>
          </Stack>
        </Box>
        <Box
          // p={[4, 8]}
          px={['25px', '35px', '45px']}
          py={['20px', '25px']}
          width='full'
          flex={1}
          overflow={'hidden'}
          borderRadius={'0px 10px 10px 0px'}
        >
          {blogLoading ?
            <Stack w='full' height='full' justifyContent='center' alignItems={'center'}>
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='teal.500'
                mt={'25%'}
                size={['md', 'xl']}
              />
            </Stack> :
            (latestBlog ?
              <Link
                as={RouterLink}
                to={`/blog/${latestBlog.wordsUrl || latestBlog.id}`}
                _hover={{
                  textDecor: 'none',
                }}
                role='group'
              >
                <Stack
                  h='full'
                  bg='white'
                  spacing='8'
                  justifyContent='center'
                  sx={{
                    // boxShadow:'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;',
                  }}
                >
                  <Box overflow='hidden'>
                    <Tag colorScheme={'teal'} size={['sm']} fontWeight='bold' mb={3}>New Post</Tag>
                    <Image
                      src={latestBlog.headerImg}
                      alt={latestBlog.blogTitle}
                      width='full'
                      // height='15rem'
                      // width="full"
                      height={{
                        base: '8rem',
                        sm: '10rem',
                      }}
                      objectFit='contain'
                      transition='all 0.2s'
                      _groupHover={{
                        transform: 'scale(1.05)',
                      }}
                    />
                  </Box>
                  <Stack spacing='3' h='auto' mt={1}>
                    {latestBlog?.category === 'news' ?
                      <Text fontSize='sm' fontWeight='bold' color='brand.1'>
                        News
                      </Text> : <Text fontSize='sm' fontWeight='bold' color='brand.1'>
                        Sendmea Tips
                      </Text>}
                    <Heading as={Text} fontSize={['20px']} noOfLines={3}>
                      {latestBlog.blogTitle}
                    </Heading>
                    <Text fontSize={['14px']} fontWeight='semibold' color='' noOfLines={3}>
                      {latestBlog.blogDesc}
                    </Text>
                    {/* <Text color="muted">{latestBlog.blogContent}</Text> */}
                  </Stack>
                  <HStack >
                    <Avatar
                      src={
                        shortLogo
                        // 'https://res.cloudinary.com/codeshock/image/upload/v1675392551/cool_q9bunp.png'
                      }
                      boxSize='10' bg='transparent'
                    />
                    <Box fontSize='sm'>
                      <Text color='brand.1' fontWeight='medium'>
                        Sendmea
                      </Text>
                      <Text color='muted'>
                        <chakra.span color='gray.600' fontWeight='500'>
                          Published at{' '}
                        </chakra.span>
                        {format(
                          new Date(
                            latestBlog?.publishedAt?.toDate()?.toDateString() || '01-01-2023'
                          ),
                          'MMM dd yyyy'
                        )}
                      </Text>
                    </Box>
                  </HStack>

                  <Stack alignItems='flex-start' mt={4}>
                    <Button
                      variant={'ghost'}
                      bg='gray.100'
                      // as={Link}
                      size={'sm'}
                      to={`/blog/${latestBlog.wordsUrl || latestBlog.id}`}
                      onClick={() => window.open(`${window.location.origin}/blog/${latestBlog.wordsUrl || latestBlog.id}`, '_blank')}
                    >
                      Read more...
                    </Button>
                  </Stack>
                </Stack>
              </Link> : null
            )}
        </Box>

      </Stack>
    </Flex >
  )
}
